var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlobShape3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300,300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131,-207.6C159.9,-185.2,166.8,-132.3,189.3,-85.7C211.8,-39.1,249.9,1.2,250.5,39.9C251,78.7,213.9,116,176.1,143.9C138.4,171.9,99.9,190.5,58,207.2C16.2,223.9,-29.1,238.6,-74.6,234.3C-120.1,230,-165.9,206.7,-194.4,170.3C-222.9,134,-234.2,84.6,-230.5,39.7C-226.7,-5.3,-208,-45.8,-184.5,-78.9C-161.1,-112,-133,-137.6,-101.5,-158.9C-69.9,-180.1,-35,-197.1,8,-209.5C51,-222,102,-230,131,-207.6Z",
    fill: "#A1F21C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobShape3);
export default __webpack_public_path__ + "static/media/blob-shape-3.9bcbf596103d2fdf42fda2c6627d5245.svg";
export { ForwardRef as ReactComponent };